'use client';
import { createStyles, getSize, expandResponsive } from '@s7/styles';
import { getColorStyles } from './utils/getColorStyles/getColorStyles.js';
import { consolidateParams } from './utils/consolidateParams/consolidateParams.js';
import { getLineClamp } from './utils/getLineClamp/getLineClamp.js';
import { getTruncate } from './utils/getTruncate/getTruncate.js';
import { getTextDecoration } from './utils/getTextDecoration/getTextDecoration.js';
import { getLineHeightByFontSize } from './utils/getLineHeightByFontSize/getLineHeightByFontSize.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var getTypographyStyles = function(theme, localParams, rootParams) {
    var _theme_typography = theme.typography, letterSpacing = _theme_typography.letterSpacing, typographyWeights = _theme_typography.weights;
    var lineClamp = localParams.lineClamp, truncate = localParams.truncate, underline = localParams.underline, strikethrough = localParams.strikethrough, align = localParams.align, italic = localParams.italic, transform = localParams.transform, inline = localParams.inline, color = localParams.color, weight = localParams.weight, weights = localParams.weights, height = localParams.height, heights = localParams.heights, size = localParams.size, sizes = localParams.sizes, family = localParams.family, spacing = localParams.spacing;
    var _ref = rootParams || {}, defaultHeights = _ref.heights, defaultWeights = _ref.weights, defaultSizes = _ref.sizes, defaultSize = _ref.size, defaultHeight = _ref.height;
    var _weights = weights || defaultWeights;
    var _heights = heights || defaultHeights;
    var _sizes = sizes || defaultSizes;
    var _size = size || defaultSize;
    var _height = height || defaultHeight;
    var _weights_weight, _ref1;
    return _extends({}, family && {
        fontFamily: family
    }, getColorStyles(theme, color), getLineClamp(lineClamp), getTruncate({
        truncate: truncate
    }), (underline || strikethrough) && {
        textDecoration: getTextDecoration({
            underline: underline,
            strikethrough: strikethrough
        })
    }, _size && {
        fontSize: getSize({
            size: _size,
            sizes: _sizes
        })
    }, (inline || _height || _size) && {
        lineHeight: inline ? 1 : getSize(_extends({
            sizes: _heights,
            size: _height != null ? _height : _size
        }, !_height && {
            mapper: getLineHeightByFontSize
        }))
    }, spacing && {
        letterSpacing: getSize({
            size: spacing,
            sizes: letterSpacing
        })
    }, weight && {
        fontWeight: (_ref1 = (_weights_weight = _weights == null ? void 0 : _weights[weight]) != null ? _weights_weight : typographyWeights == null ? void 0 : typographyWeights[weight]) != null ? _ref1 : weight
    }, transform && {
        textTransform: transform
    }, align && {
        textAlign: align
    }, italic && {
        fontStyle: "italic"
    });
};
var expandResponsiveTypographyStyles = function(theme, breakpoints, variants, rootParams) {
    return expandResponsive(theme)(breakpoints)(function(localParams) {
        var variant = localParams.variant;
        var consolidatedLocalParams = variant ? consolidateParams(localParams, variants == null ? void 0 : variants[variant]) : localParams;
        return getTypographyStyles(theme, consolidatedLocalParams, rootParams);
    });
};
var deriveColorFromThemeTypography = function(theme) {
    var _theme_fn = theme.fn, themeColor = _theme_fn.themeColor, primaryShade = _theme_fn.primaryShade;
    return {
        color: primaryShade(themeColor(theme.typography.color))
    };
};
/**
 * Предназначено, в том числе, для генерации базовых стилей типографики в других компонентах.
 * Это позволяет не привязывать отображение типографики в них к компоненту Typography.
 * */ var deriveThemeTypographyStyles = function(theme, params) {
    if (params === void 0) params = {};
    var _params_family;
    return _extends({
        boxSizing: "border-box",
        WebkitTapHighlightColor: "transparent",
        WebkitTextFillColor: "initial",
        fontFamily: (_params_family = params.family) != null ? _params_family : theme.typography.fontFamily
    }, params.color ? getColorStyles(theme, params.color) : deriveColorFromThemeTypography(theme));
};
var useStyles = createStyles(function(theme, _param, _param1) {
    var breakpoints = _param.breakpoints, variants = _param.variants, preWrap = _param.preWrap, rootParams = _object_without_properties_loose(_param, [
        "breakpoints",
        "variants",
        "preWrap"
    ]), variant = _param1.variant;
    var consolidatedRootParams = consolidateParams(rootParams, variants == null ? void 0 : variants[variant]);
    return {
        root: _extends({}, preWrap && {
            whiteSpace: "pre-wrap"
        }, deriveThemeTypographyStyles(theme, consolidatedRootParams), getTypographyStyles(theme, consolidatedRootParams), expandResponsiveTypographyStyles(theme, breakpoints, variants, consolidatedRootParams))
    };
});

export { useStyles as default, deriveThemeTypographyStyles, expandResponsiveTypographyStyles, getTypographyStyles };
